(() => {
  if (window.__tblNativeSaleLoaded) return;
  window.__tblNativeSaleLoaded = true;

  const initRoot = (root) => {
    if (root.dataset.tblNativeSaleInitialized === 'true') return;
    root.dataset.tblNativeSaleInitialized = 'true';

    let queued = false;
    const sync = () => {
      queued = false;
      const imageBadge = root.querySelector('[data-tbl-native-sale-image-badge]');
      if (!imageBadge) return;

      const priceBadge = root.querySelector('[data-tbl-native-sale-percent]');
      if (!priceBadge) return;

      const label = (priceBadge.dataset.tblNativeSaleLabel || priceBadge.textContent || '').trim();

      if (imageBadge.textContent.trim() !== label) imageBadge.textContent = label;
      imageBadge.hidden = label.length === 0;
      imageBadge.setAttribute('aria-label', label);
    };

    const queueSync = () => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(sync);
    };

    new MutationObserver(queueSync).observe(root, { childList: true, subtree: true });
    sync();
  };

  const init = () => {
    document.querySelectorAll('[data-tbl-native-sale-root]').forEach(initRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();